import { render, staticRenderFns } from "./ButtonOptions.vue?vue&type=template&id=6dac2f13&scoped=true"
import script from "./ButtonOptions.vue?vue&type=script&lang=ts"
export * from "./ButtonOptions.vue?vue&type=script&lang=ts"
import style0 from "./ButtonOptions.vue?vue&type=style&index=0&id=6dac2f13&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dac2f13",
  null
  
)

export default component.exports